import TanoProjo from './TanoProjo';
import { useEnvolPrenoms } from './useEnvolPrenoms';
import { QCM_GREEN, FONT_TITRE } from '../../utils/qcmTheme';

/**
 * Bande du bas de la projection (navy) : prénoms en attente de scan (pills
 * qui « s'envolent » quand l'élève est scanné), message « ✓ Toute la classe
 * a répondu ! » quand c'est complet, et bouton discret de révélation.
 *
 * Depuis le lot « levez vos cartes » (2026-09-19), c'est l'écran des séances
 * dont le serveur ne connaît pas l'ouverture du scan ; sinon la projection
 * montre `ScanScreen`, plein écran, avec le même envol.
 *
 * `nonRepondants` : [{ code_aruco, nom }] (logique conservée de ProjectionQCM).
 * `complet` est calculé par ProjectionQCM sur la MÊME source que les pills
 * (participants) — pas sur nb_eleves, qui compte les absents.
 */
const WaitingBand = ({ nonRepondants, complet, nbReponses, onReveal }) => {
  const pills = useEnvolPrenoms(nonRepondants);

  return (
    <div className="mt-auto flex-shrink-0 text-white px-9 pt-4 pb-6 bg-white/[0.06]" style={{ borderTop: '1px solid rgba(255,255,255,.1)' }}>
      <div className="flex items-center justify-between mb-3">
        <h3
          className="font-bold text-[11px] uppercase text-white/50"
          style={{ letterSpacing: '.16em', fontFamily: FONT_TITRE }}
        >
          {complet ? 'Terminé' : 'En attente de scan'}
        </h3>
        {nbReponses > 0 ? (
          <button
            type="button"
            onClick={onReveal}
            className="text-[12px] font-bold px-3.5 py-1.5 rounded-full transition hover:bg-white/20"
            style={{ background: 'rgba(255,255,255,.1)', border: '1px solid rgba(255,255,255,.25)' }}
          >
            Révéler les réponses
          </button>
        ) : null}
      </div>

      {complet ? (
        <div className="flex items-center gap-4">
          <TanoProjo variant="entree" mood="joy" size={72} />
          <p className="proj-check-pop font-black py-1" style={{ color: QCM_GREEN, fontSize: 'clamp(20px, 2.6vw, 30px)', fontFamily: FONT_TITRE }}>
            ✓ Toute la classe a répondu !
          </p>
        </div>
      ) : (
        <div className="flex flex-wrap gap-2" style={{ minHeight: 44 }}>
          {pills.map((p) => (
            <span
              key={p.code_aruco}
              className={`proj-name font-semibold px-3.5 py-2 rounded-full whitespace-nowrap${p.bye ? ' proj-name-bye' : ''}`}
              style={{
                background: 'rgba(255,255,255,.09)',
                border: '1px solid rgba(255,255,255,.15)',
                fontSize: 'clamp(13px, 1.5vw, 17px)',
              }}
            >
              {p.nom}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default WaitingBand;
